export const normalizeAvatarName = (name) =>
  name
    .toLowerCase()
    .replace(/[()]/g, "")
    .replace(/[^a-z0-9]/gi, "_")
    .replace(/_+/g, "_")
    .trim();

export const SPRITES_MAP = {
  zay: require("../assets/avatars/zay/zay.png"),
  infinty_orb: require("../assets/avatars/InfintyOrbs/green.png"),
  io_default: require("../assets/avatars/InfintyOrbs/green.png"),
  infinity_orb_red: require("../assets/avatars/InfintyOrbs/red.png"),
  infinity_orb_blue: require("../assets/avatars/InfintyOrbs/blue.png"),
  infinity_orb_yellow: require("../assets/avatars/InfintyOrbs/yellow.png"),
  infinity_orb_purple: require("../assets/avatars/InfintyOrbs/purple.png"),
  infinity_orb_orange: require("../assets/avatars/InfintyOrbs/orange.png"),
  infinity_orb_pink: require("../assets/avatars/InfintyOrbs/pink.png"),
  infinity_orb_void: require("../assets/avatars/InfintyOrbs/void.png"),
  infinity_orb_white: require("../assets/avatars/InfintyOrbs/white.png"),
};
